import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';

// import "./style-complete-interested.css";
import UseCompleteInterestedReseller from '../../../../../controller/account-ctr/complete-create-account-reseller/use-complete-interested-reseller';
// import { ReactComponent as Loader } from "../../../../../resources/images/loader-chargement.svg";
import Header from '../../../../widget/header-logo-center/header-logo-center';
import { checkIfExist, getSStorage } from '../../../../../utils';

const useStyles = makeStyles({
  customStyles: {
    color: '#f16627',
  },
  checked: {
    color: '#f16627',
  },
});

export default function CompleteInterestedResseller() {
  const {
    dataInterested,
    dataChecked,
    loader,
    params,
    history,
    checkedRadio,
    navigateCompleteInfo,
  } = UseCompleteInterestedReseller();

  const sess = getSStorage('emailReseller');

  if (!checkIfExist(sess)) {
    return <Redirect to='/complete-info-reseller' />;
  }

  return (
    <div>
      <Header />
      <div className={`loader-container ${loader ? 'd-flex' : 'd-none'}`}></div>
      <div className='getstartedContainer'>
        <div className='head-getstarted mini'>
          <a className='link-back' onClick={() => history.goBack()}>
            <span className='icon-back'></span>
          </a>
          <h1>Tell us what topics are you interested in.</h1>
        </div>
        {/* {loader && <Loader />} */}

        <div className='contentBorder justify-content-center flex-wrap  content-link-topic d-flex pb-3'>
          {dataInterested
            ?.filter(
              (element: any, index: number) =>
                element?.main && element?.icone !== ''
            )
            ?.map((v: any, index: number) => (
              <div
                key={index}
                onClick={() => checkedRadio(v.id)}
                className={`link-topic ${
                  dataChecked && dataChecked?.find((el) => el == v.id)
                    ? 'active'
                    : ''
                }`}
              >
                {<div dangerouslySetInnerHTML={{ __html: v && v.icone }} />}
                <span>{v.title}</span>
              </div>
            ))}
        </div>
        <div className='contentBorder py-3 border-top d-flex flex-wrap checkListTopic'>
          {dataInterested
            ?.filter((element) => !element.main || element.icone === '')
            .map((element, index: number) => (
              <div
                className='custom-control custom-checkbox getstartedcheckbox'
                key={index}
              >
                <input
                  type='checkbox'
                  className='custom-control-input'
                  id={`checkbox${element.id}`}
                  defaultChecked={
                    dataChecked && dataChecked.find((el) => el == element.id)
                      ? true
                      : false
                  }
                />
                <label
                  className='custom-control-label'
                  htmlFor={`checkbox${element.id}`}
                  onClick={() => checkedRadio(element.id)}
                >
                  {element.title}
                </label>
              </div>
            ))}
        </div>
        <div className='contentBorder row align-items-stretch'>
          <div className='col-12 d-flex align-items-center p-0'>
            <button
              className='btn btn-devinsider large'
              onClick={() =>
                dataChecked && dataChecked.length >= 3
                  ? navigateCompleteInfo()
                  : null
              }
            >
              {dataChecked && dataChecked.length >= 3
                ? 'Next'
                : `Select at least ${3 - dataChecked.length} more`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
